/* __next_internal_client_entry_do_not_use__ Navigation auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { LoginButton } from "../LoginButton";
import { useEffect, useState } from "react";
import "./index.css";
import eventTracker, { LoggingAction } from "@/handle/newDataWareHose";
import { usePathname } from "next/navigation";
export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();
  const handleScroll = e => {
    const scrollHeight = e.target.scrollTop;
    if (scrollHeight > 60) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  useEffect(() => {
    const page = document.getElementById("page");
    page === null || page === void 0 ? void 0 : page.addEventListener("scroll", handleScroll);
    return () => {
      page === null || page === void 0 ? void 0 : page.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const isnew = localStorage.getItem("uniqueID");
    if (isnew) {
      eventTracker.loggingEvent(LoggingAction.USERPATH, {
        isnew: false
      });
    } else {
      eventTracker.loggingEvent(LoggingAction.USERPATH, {
        isnew: true
      });
    }
  }, [pathname]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames({
      ["global-nav"]: true,
      ["scrolled"]: isScrolled
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "global-nav-left",
      children: /*#__PURE__*/_jsx("a", {
        href: "https://a1.art",
        target: "_blank",
        children: /*#__PURE__*/_jsx("img", {
          width: "80",
          src: "https://txcdn-prod-a1art.xiaopiu.com/assets/Resource/image/logo@4x.png",
          alt: ""
        })
      })
    }), /*#__PURE__*/_jsx(LoginButton, {})]
  });
};